import React from 'react'
import ContactHeroSection from './ContactPage/ContactHeroSection'
import Navbar from '../Header/Navbar'
import ContactSection from './ContactPage/ContactSection'
import Footer from '../Footer/Footer'
import MapSection from '../MapSection/MapSection'

function Contact() {
    return (
        <div>
            <Navbar/>
            <ContactHeroSection/>
            <ContactSection/>
            <MapSection/>
            <Footer/>
        </div>
    )
}

export default Contact
